import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Box from 'ui-box';
import AntdAlertErrorBoundary from '../../components/common/AntdAlertErrorBoundary';
import MobileHeader from '../../components/mobile/Header';
import AppointmentScreen from '../../pages/mobile/appointment/AppointmentScreen';
import AppointmentDetailScreen from '../../pages/mobile/appointment/AppointmentDetailScreen';

function MobileAppointmentLayout() {

  return (
    < >
      <Box position="relative" height="100%">
        <AntdAlertErrorBoundary>
          <MobileHeader />
        </AntdAlertErrorBoundary>
        <AntdAlertErrorBoundary>
          <Switch>
            <Route path="/appointment/detail/:id">
              <AppointmentDetailScreen />
            </Route>
            <Route path="/appointment">
              <AppointmentScreen />
            </Route>
          </Switch>
        </AntdAlertErrorBoundary>
      </Box>
    </>
  );
}

export default MobileAppointmentLayout;
